document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('product-info[data-update-url="false"]').forEach(function (info) {
    var url = info.getAttribute('data-url');
    if (!url) return;
    info.querySelectorAll('.product__modal-opener').forEach(function (opener) {
      opener.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = url;
        },
        true
      );
    });
  });
});

document.addEventListener('click', function (e) {
  var btn = e.target.closest('.fb-card__cart-badge');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  var variantId = btn.getAttribute('data-variant-id');
  var productUrl = btn.getAttribute('data-product-url') || '/';
  if (!variantId) return;
  btn.classList.add('is-loading');
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({ id: variantId, quantity: 1 })
  })
    .then(function (res) {
      if (!res.ok) throw new Error('add failed');
      return res.json();
    })
    .then(function () {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      window.location.href = productUrl;
    })
    .catch(function () {
      window.location.href = '/cart/add?id=' + variantId + '&quantity=1&return_to=' + encodeURIComponent(productUrl);
    });
});
